import { Checkbox, FormControlLabel, Grid } from '@mui/material';
import React from 'react';

const LocationFilter = (props) => {
    const { onChange, searchFilter, isEcec } = props
    const locationList = [
        { id: 'Melbourne', value: 'Melbourne', label: 'Melbourne' },
        { id: 'Sydney', value: 'Sydney', label: 'Sydney' },
        { id: 'Brisbane', value: 'Brisbane', label: 'Brisbane' },
        { id: 'Gold Coast', value: 'Gold Coast', label: 'Gold Coast' },
        { id: 'Perth', value: 'Perth', label: 'Perth' },
        { id: 'Adelaide', value: 'Adelaide', label: 'Adelaide' },
        { id: 'online_only', value: 'online_only', label: 'Online only' },
    ]

    const locationListECEC = [
        { id: 'Melbourne', value: 'Melbourne', label: 'Melbourne' },
        { id: 'Sydney', value: 'Sydney', label: 'Sydney' },
        // { id: 'Brisbane', value: 'Brisbane', label: 'Brisbane' },
        // { id: 'Gold Coast', value: 'Gold Coast', label: 'Gold Coast' },
        // { id: 'Perth', value: 'Perth', label: 'Perth' },
        // { id: 'Adelaide', value: 'Adelaide', label: 'Adelaide' },
    ]

    return (
        <Grid container spacing={2}>
        {
           isEcec ? locationListECEC.map(item => {
                return (
                    <Grid item xs={6} style={{ "paddingTop": "4px" }}>
                        <FormControlLabel
                            control={<Checkbox id={item.id} value={item.value} checked={searchFilter?.locations?.includes(item.value)} />}
                            label={item.label}
                            onChange={(e) => onChange('location', e)}
                            style={{ "marginBottom": "2px" }}
                        />
                    </Grid>
                )
            }) 
            : locationList.map(item => {
                return (
                    <Grid item xs={6} style={{ "paddingTop": "4px" }}>
                        <FormControlLabel
                            control={<Checkbox id={item.id} value={item.value} checked={searchFilter?.locations?.includes(item.value)} />}
                            label={item.label}
                            onChange={(e) => onChange('location', e)}
                            style={{ "marginBottom": "2px" }}
                        />
                    </Grid>
                )
            })
        }
        </Grid>
    )
}

export default LocationFilter